function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M124 176a4 4 0 01-3-1.3l-43-48a4.003 4.003 0 016-5.3l43 48a4 4 0 01-3 6.7z",
  fill: "#d8d8d8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M67.8 172l43.2-48"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M67.8 176a4 4 0 01-3-6.7l43.2-48a4 4 0 115.9 5.4l-43.2 48a4 4 0 01-2.9 1.3z",
  fill: "#d1d1d1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M95.1 133.7l-4.5 5-12.6-14a5.6 5.6 0 01-.9-1.7 4.1 4.1 0 00.9 3.7l12.6 14 5.4-6zM126.7 173a4 4 0 01-5.6-.3l-24.2-27-.9 1 25.1 28a4.2 4.2 0 005.7.3 4.1 4.1 0 001.2-3.9 6.4 6.4 0 01-1.3 1.9z",
  fill: "#c2c2c2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M124 176a4.1 4.1 0 01-3.9-3L96 81.6 71.7 173a4 4 0 01-5.2 2.2A4 4 0 0164 171L92.1 65a4 4 0 013.9-3 4.1 4.1 0 013.9 3l28 106a4 4 0 01-2.9 4.9z",
  fill: "#f4f4f4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M124 176a4.1 4.1 0 01-3.9-3L96 81.6 71.7 173a4 4 0 01-5.2 2.2A4 4 0 0164 171L92.1 65a4 4 0 013.9-3 4.1 4.1 0 013.9 3l28 106a4 4 0 01-2.9 4.9z",
  fill: "#f4f4f4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M127.9 171L100.7 68h-9.3L64 171a4 4 0 007.7 2L96 81.6l24.1 91.4a4.02 4.02 0 107.9-1.5c0-.2-.1-.3-.1-.5z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.9 65a4 4 0 00-3.9-3 4.1 4.1 0 00-3.9 3l-.8 3h9.3z",
  fill: "#4a4d4e"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "d90a147c-6416-4654-ae22-207eabce3c96",
  d: "M152.2 19.5a72.8 72.8 0 010 102.9h0",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "65955a09-71f1-4d99-b7cc-2dc93957b086",
  d: "M136.6 34.4a52 52 0 010 73.5",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "158d2709-97aa-4382-834c-824a579fae81",
  d: "M121.3 49.7a30.2 30.2 0 010 42.7",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "f7826cb2-87de-4942-bc78-d40f0f8b5447",
  d: "M38.9 19.5a72.8 72.8 0 000 102.9h0",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  "data-name": "d3aaf896-b68d-4a5b-8ea1-2dd004190418",
  d: "M54.5 34.4a52 52 0 000 73.5",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  "data-name": "852f9ebf-918a-496c-8386-8d03fe8586c1",
  d: "M69.8 49.7a30.2 30.2 0 000 42.7",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.29
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M153.6 121.9a2.2 2.2 0 01-3 0l-.4-.5a2.1 2.1 0 00.9 2.9 2.1 2.1 0 002.5-.4A74.6 74.6 0 00175.5 70a74.5 74.5 0 01-21.9 51.9zM153.9 70.2a53.6 53.6 0 01-15.9 37.3 2.2 2.2 0 01-3 0l-.4-.5a2.1 2.1 0 00.9 2.9 2.1 2.1 0 002.5-.4 54.5 54.5 0 0015.9-39.3zM121.2 92.6a2.1 2.1 0 01-1.9-1.1 2.1 2.1 0 00.9 2.9 2.1 2.1 0 002.5-.4 32.3 32.3 0 009.5-22.9v-1a32.2 32.2 0 01-9.4 21.9 2.8 2.8 0 01-1.6.6zM38.9 122.5a2 2 0 01-1.5-.6A74.5 74.5 0 0115.5 70a74.8 74.8 0 0021.9 54 2.2 2.2 0 003 0 2.1 2.1 0 00.4-2.5 1.9 1.9 0 01-1.9 1zM54.5 108.1a2 2 0 01-1.5-.6 53.7 53.7 0 01-15.8-37.3A54 54 0 0053 109.5a2.2 2.2 0 003 0 2.1 2.1 0 00.4-2.5 2.4 2.4 0 01-1.9 1.1zM69.8 92.6a2 2 0 01-1.5-.6 32.1 32.1 0 01-9.5-22v1a32.3 32.3 0 009.5 22.9 2.2 2.2 0 003 0 2.1 2.1 0 00.4-2.5 2.2 2.2 0 01-1.9 1.2z",
  fill: "#c10017"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#4a4d4e",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  d: "M96 45.2v17.3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var SvgNetworkSignalHiDark = function SvgNetworkSignalHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "7ba04029-b5fc-444f-88be-cf0f312921de",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    d: "M114 124.7l-12.6 14-5.4 6-25.2 28a4.2 4.2 0 01-5.7.3 3.9 3.9 0 01-1.2-1.9 4 4 0 002.9 4.8 4.1 4.1 0 003.9-1.2l25.3-28 5.4-6 12.6-14a4.1 4.1 0 00.9-3.7 5.6 5.6 0 01-.9 1.7z",
    style: {
      isolation: "isolate"
    },
    fill: "#c2c2c2"
  }), _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("path", {
    d: "M127.9 171a4 4 0 01-7.8.1L96 79.6 71.7 171a4 4 0 01-7.7 0 4 4 0 007.7 2L96 81.6l24.1 91.4a4.02 4.02 0 107.9-1.5c0-.2-.1-.3-.1-.5z",
    style: {
      isolation: "isolate"
    },
    fill: "#f0f0f0"
  }), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

export default SvgNetworkSignalHiDark;